export default {
  methods: {
    setText(timeText = 'timeText') {
      setTimeout(() => {
        if (this[timeText] >= 0) {
          this[timeText]--;
          if (timeText) {
            this.setText(timeText);
          } else {
            this.setText();
          }
        }
      }, 1000);
    }
  }
};
